/* 
 * Export component file to be used on project
*/

import FloatmenuCard from './FloatmenuCard.js';
export default FloatmenuCard;